<template>
  <v-card>
    <v-layout
      justify-space-between
      pa-3
    >
      <app-section-loader :status="folderloader"></app-section-loader>
      <v-flex xs3>
        <vue-perfect-scrollbar
          class="chat-room--scrollbar grey lighten-5"
          v-bind:style="computeHeight"
        >
          <v-treeview
            :active.sync="active"
            :items="items"
            :open.sync="open"
            activatable
            active-class="primary--text"
            transition
            v-model="selectedFolder"
            :open-all="true"
          >

          </v-treeview>
        </vue-perfect-scrollbar>
      </v-flex>

      <v-flex
        d-flex
        xs9
      >
        <vue-perfect-scrollbar
          class="chat-room--scrollbar lighten-5"
          v-bind:style="computeHeight"
        >
          <v-scroll-y-transition mode="out-in">
            <div
              v-if="!selected"
              class="title grey--text text--lighten-1 font-weight-light"
              style="align-self: center;"
              text-xs-center
            >
              <v-card flat>
                <folder-Form ref="reffolderfiles"></folder-Form>
              </v-card>
            </div>
            <v-card
              v-else
              :key="selected.folderID"
              class="pt-4 mx-auto"
              flat
            >
              <!-- <v-card-text>
                <v-hover
                  open-delay="0"
                  close-delay="0"
                >
                 
                  <v-layout slot-scope="{ hover }">
                    <v-flex
                      sm5
                      lg5
                    >
                      <h3
                        v-if="selected.hasPermission == true"
                        class="headline"
                      >
                        {{ selected.name | uppercase }}

                      </h3>
                      <h3
                        v-else
                        class="headline"
                        style="color:red;"
                      >
                        Name : {{ selected.name | uppercase }}

                      </h3>
                    </v-flex>
                    <v-flex
                      sm7
                      lg7
                    >
                      <h3
                        v-if="selected.hasPermission == true"
                        class="headline"
                      >
                        {{ selected.addedDate | formatDate }}

                      </h3>
                      <h3
                        v-else
                        class="headline"
                        style="color:red;"
                      >
                        Added Date : {{ selected.addedDate | formatDate }}

                      </h3>
                    </v-flex>
                    <v-flex>
                      <v-btn
                        icon=""
                        v-if="selected.hasPermission == true"
                        @click="addFolder(selected)"
                      >
                        <v-icon>
                          add_circle_outline
                        </v-icon>
                      </v-btn>
                      <v-btn
                        icon=""
                        v-if="selected.hasPermission == true"
                        @click="editFolder(selected)"
                      >
                        <v-icon>
                          edit
                        </v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-hover>
              </v-card-text> -->
              <v-divider></v-divider>
              <v-card flat>
                <folder ref="reffolderfiles"></folder>
              </v-card>
              <!-- <v-layout
                tag="v-card-text"
                wrap
              >
                <v-flex v-if="selected.hasPermission == true">
                  <div v-html="selected.description"></div>
                </v-flex>
                <v-flex v-else>
                  <div v-html="selected.name"></div>
                  <div v-html="selected.description"></div>
                </v-flex>
              </v-layout> -->
            </v-card>
          </v-scroll-y-transition>
        </vue-perfect-scrollbar>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="subdialog"
      max-width="800px"
    >

      <v-card>

        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <!-- <new-folder ref="refNewFolderForm"></new-folder> -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            outline
            @click.native="subdialog = false"
          >Cancel</v-btn>
          <v-btn
            color="primary darken-1"
            outline
            @click.native="saveFolder"
          >Save</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

  </v-card>

</template>
<script>
import SubFolder from '@/pages/document/subfolder';
import folderForm from '@/pages/document/folderForm';
import Folder from '@/pages/document/Folder';
// import { getSubTasksId, getTaskTreeId, getTaskMastersbyID } from '@/api/taskMaster';
import { getFolders, getFolderTypes, getSubFoldersId, getFolderTreeId, getSubFolders, getFolder, createFolders, updateFolders, deleteFolders } from '@/api/folder';
const pause = ms => new Promise(resolve => setTimeout(resolve, ms))

export default {
  components: {
    SubFolder,
    folderForm,
    Folder
  },
  data: () => ({
    height: {
      type: String,
      default: null,
    },
    selectedTab: null,
    actionButton: true,
    subdialog: false,
    selecteditem: false,
    active: [],
    avatar: null,
    open: [],
    users: [],
    folderItems: [],
    subFolderitems: [],
    folderID: -1,
    formTitle: 'Sub Folder',
    formdata: {
      valid: false,
      folderID: -1,
      date: new Date(),
      name: '',
      description: '',
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date(),
      addedByUser: 'Arun',
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      addedByUser: 'Arun',
      attachments: [],
      folderTypeID: -1,
      mainFolderId: null,
      parentFolderID: null,
    },
    folderloader: false,
    foldertriggered: false,
    selectedFolder: [],
  }),
  created () {
    this.initialize();
    window.getApp.$on('ENABLE_FOLDERACTION', () => {
      this.actionButton = false;
      this.selectedTab = null;
    });
    window.getApp.$on('DISABLE_TAB', action => {
      this.actionButton = action;
      this.selectedTab = null;
    });
    window.getApp.$on('SEND_FOLDEROBJ', objFolder => {
      this.formdata = objFolder;
    });
  },
  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      };
    },
    selected () {
      //let userId = this.$store.state.auth.userId;
      if (!this.active.length) return undefined
      const id = this.active[0]
      this.folderID = id;
      this.selecteditem = true;

      getFolders()
        .then(response1 => {
          this.folderItems = response1.data;
          this.folderloader = false;

        })
        .catch(error => {
          this.folderloader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      // getSubFoldersId(this.folderID, userId)
      //   .then(response2 => {
      //     this.folderItems = response2.data;
      //     this.folderloader = false;

      //   })
      //   .catch(error => {
      //     this.folderloader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);
      //   });

      // console.log(this.folderItems);
      return this.folderItems.find(folder => folder.folderID == id);
      console.log(this.folderItems);
    },
    items () {
      return this.subFolderitems;
      return this.folderItems;
    },
  },

  watch: {

  },
  // getSubFolders (item) {
  //   console.log(item)
  //   getFolderFiles(item.folderID)
  //     .then(response3 => {
  //       this.folderItems = response3.data;
  //       this.folderloader = false;

  //     })
  //     .catch(error => {
  //       this.folderloader = false;
  //       window.getApp.$emit('APP_API_ERROR', error);
  //     });
  // },
  methods: {

    initialize () {
      this.folderloader = true;
      let userId = this.$store.state.auth.userId;
      // let name = this.$store.folder.name;
      // console.log(this.name);
      //  getFolders()
      //   .then(response4 => {
      //     this.subFolderitems = response4.data;
      //     this.folderloader = false;

      //   })
      //   .catch(error => {
      //     this.folderloader = false;
      //     window.getApp.$emit('APP_API_ERROR', error);
      //   });


      getFolderTreeId(this.folderID, userId)
        .then(response3 => {
          this.subFolderitems = response3.data;
          this.folderloader = false;

        })
        .catch(error => {
          this.folderloader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      getSubFoldersId(this.folderID, userId)
        .then(response4 => {
          this.formdata = response4.data;
          //window.getApp.$emit('SEND_FOLDEROBJ', this.formdata);
          this.folderloader = false;

        })
        .catch(error => {
          this.folderloader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });


    },
    formateDate (string) {
      return string ? new Date(string).toLocaleDateString() : '';
    },

    editFolder (item) {

      setTimeout(() => {
        window.getApp.$emit('SEND_FOLDEROBJ', this.formdata);
        window.getApp.$emit('EDIT_SUBFOLDER', item);
      }, 300);
      this.subdialog = true;
    },
    addFolder (item) {
      console.log(item);

      setTimeout(() => {
        window.getApp.$emit('SEND_FOLDEROBJ', this.formdata);
        window.getApp.$emit('ADD_SUBFOLDER', item);
      }, 300);
      this.subdialog = true;
    },
    saveFolder () {
      this.documenttriggered = false;

      window.getApp.$emit('SAVE_SUBFOLDER', this.folderID);
      window.getApp.$emit('SEND_FOLDEROBJ', this.formdata);
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/document/PublicFolder.vue